export default __webpack_public_path__ + "static/media/AmbulanceService.22fda939.jpg";